import { Pipe, PipeTransform } from '@angular/core';
import { exchange } from './exchange';
import { isUndefined, core } from '@icc/shared/helpers/b2b';
import { Currency } from './currency.interface';
import { ExchangeRate } from './exchange-rate.interface';
import { ExchangeRateService } from './exchange-rate.service';

@Pipe({name: 'exchange'})
export class ExchangePipe implements PipeTransform {

    constructor(private exchangeRateService: ExchangeRateService) {}

    transform(data: any, from?: string | Currency, to?: string | Currency, exchangeRates?: ExchangeRate[]): number | null {
        if (!from) {
            from = this.exchangeRateService.getBuyCurrency();
        }
        if (typeof from === 'object') {
            from = from.code;
        }
        if (!to) {
            to = this.exchangeRateService.getMainCurrency();
        }
        if (typeof to === 'object') {
            to = to.code;
        }
        if (!exchangeRates) {
            exchangeRates = this.exchangeRateService.getRates() ?? [];
        }
        return exchange(data, from, to, exchangeRates);
    }
  }
